import { Button } from "@src/appV2/redesign/components/Button";
import { Pill } from "@src/appV2/redesign/components/Pill";
import { Text } from "@src/appV2/redesign/components/Text";
import { getWorkerStageLabel, isWorkerStageEnum } from "@src/appV2/redesign/utils/worker";

interface AccountSwitcherOptionProps {
  headline: string;
  subtitles?: string[];
  stage?: string;
  onClick?: () => void;
}

function getStageLabel(stage: string): string {
  if (isWorkerStageEnum(stage)) {
    return getWorkerStageLabel(stage).toUpperCase();
  }

  return stage.toUpperCase();
}

export function AccountSwitcherOption(props: AccountSwitcherOptionProps) {
  const { headline, subtitles, stage, onClick } = props;

  return (
    <Button
      fullWidth
      sx={{
        height: "auto",
        flexDirection: "column",
        alignItems: "start",
      }}
      variant="outlineInverted"
      onClick={onClick}
    >
      <Text
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.navbar?.itemContentSelected,
          fontWeight: 500,
        })}
      >
        {headline}
      </Text>
      {subtitles?.map((subtitle) => (
        <Text
          key={subtitle}
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.navbar?.itemContent,
          })}
        >
          {String(subtitle)}
        </Text>
      ))}

      {stage && <Pill>{getStageLabel(stage)}</Pill>}
    </Button>
  );
}
